import {Inject, Injectable, Renderer2} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AppTranslationService} from './app-translation.service';
import {AppConfig} from '../config/app-config';
import {DOCUMENT} from '@angular/common';
import {CourseShopOptionsModel} from '../../../oj-app-common/shop/models/course-shop-options.model';
import {CourseCombinedModel} from '../../../oj-app-common/shop/models/shop/course-combined.model';
import * as CryptoJS from 'crypto-js';
import {CookieManagementService} from './cookie.service';
import {UserProfile} from '../../../oj-app-common/eshop-api/models/user-profile';

@Injectable({
  providedIn: 'root',
})
export class AffiliateService {

  searchingParams: AffiliateModel = {
    oj_id: '',
    oj_source: '',
    lang: ''
  };

  STORAGE_KEY = 'affiliate';

  constructor(
    protected http: HttpClient,
    protected appTranslationService: AppTranslationService,
    protected appConfig: AppConfig,
    @Inject(DOCUMENT) private _document: Document,
    private cookieService: CookieManagementService
  ) {

  }

  initializeGTM() {
    if (this.appConfig.gtmContainerId) {
      window['dataLayer'] = window['dataLayer'] || [];
      const alreadyLoaded = window['dataLayer'].some(
        (entry) => entry['gtm.start'] && document.querySelector(`script[src*="${this.appConfig.gtmContainerId}"]`)
      );
      if (!alreadyLoaded) {
        (function(w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
          let j: HTMLScriptElement = d.createElement(s) as HTMLScriptElement;
          let f = d.getElementsByTagName(s)[0], dl = l !== 'dataLayer' ? '&l=' + l : '';
          j.async = true;
          j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', this.appConfig.gtmContainerId);
      }
      if (!window['gtag']) {
        window['gtag'] = function(data) {
          window['dataLayer'].push(data);
        };
      }
    }
  }

  parseUrl(url: string) {
    // parse params from url and store into searchingParams variable
    const uri = new URL(url);
    Object.keys(this.searchingParams)
      .forEach(key => {
        if (uri.searchParams.get(key)) {
          this.searchingParams[key] = uri.searchParams.get(key);
        }
      });

    console.log('affiliate params successfully loaded');
    this.set(this.searchingParams);
  }

  // set value to local storage
  set(val: AffiliateModel) {
    const data = localStorage.getItem(this.STORAGE_KEY);
    if (data) {
      localStorage.removeItem(this.STORAGE_KEY);
    }
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(val));
  }

  // get value from local storage
  get(): AffiliateModel {
    const val = localStorage.getItem(this.STORAGE_KEY);

    if (val) {
      return JSON.parse(val);
    }
    return null;
  }

  // clear local storage
  clear() {
    localStorage.removeItem(this.STORAGE_KEY);
  }

  send(email: string, studentId: number, renderer2: Renderer2) {
    const storedValue = this.get();

    if (!storedValue || !email) {
      console.log('there is no any affiliate values');
      return;
    }

    const url = 'https://ruby-api.onlinejazyky.cz/api/students';

    const headers = new HttpHeaders();

    headers.set('Content-Type', 'application/json');

    const data: AffiliateRubyModel = {
      eshop_id: studentId,
      email,
      language: storedValue.lang,
    };

    if (this.isNotNullAndHasValue(storedValue.oj_source)) {
      data.affiliate_partner = storedValue.oj_source;
    }

    if (this.isNotNullAndHasValue(storedValue.oj_id)) {
      data.affiliate_id = storedValue.oj_id;
    }

    if (this.isNotNullAndHasValue(storedValue.lang)) {
      data.language = storedValue.lang;
    }
    // else {
    //   data.language = this.appTranslationService.currentLanguage;
    // }

    data.brand = this.appConfig.brandCode;

    this.setCookie(data);

    this.http
      .put(
        url,
        data,
        {
          headers,
        },
      )
      .subscribe(() => {
        // this.clear();
      });
  }

  setCookie(data: AffiliateRubyModel) {

    Object.keys(data)
      .forEach(k => {

        this.cookieService.setCookieIfConsented(k, data[k]);

      })
  }

  // check if variable is not null and has any value
  isNotNullAndHasValue(value: string) {
    return value && value.length > 0;
  }

  googleAnalyticsAfterLogin(method: 'email' | 'facebook' = 'email', email: string) {
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push({
      event: 'login',
      method,
      user_id: this.emailToMd5(email),
    });
  }

  identify(email: string, name?: string, language2LetterCode?: string, userData?: any) {

    if (!window['dataLayer']) {
      return;
    }

    if (!language2LetterCode) {
      language2LetterCode = (userData && userData.language) || this.appTranslationService.currentLanguage;
    }

    const language4LetterCode = AppTranslationService.languageCode2LocaleLong(language2LetterCode);

    const resolvedName = name || (userData && userData.name);

    const contactData: any = {
      'emailaddress': email || (userData && userData.email),
      'language': language4LetterCode,
    };

    if (resolvedName) {
      const nameParts = resolvedName.split(' ');
      const firstName = nameParts.length > 0 ? nameParts[0] : '';
      const lastName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';
      contactData.name = firstName;
      contactData.surname = lastName;
    }

    if (userData) {
      if (userData.phone) {
        contactData.cellphone = userData.phone;
      }
      if (userData.street) {
        contactData.street = userData.street;
      }
      if (userData.city) {
        contactData.town = userData.city;
      }
      if (userData.zip) {
        contactData.postalcode = userData.zip;
      }
      if (userData.company) {
        contactData.company = userData.company;
      }
    }

    const pushData = {
      'event': 'identify',
      'contact_data': contactData,
      'reidentify': false,
      'update_existing': true,
      'only_existing': false,
    };

    window['dataLayer'].push(pushData);

  }

  googleAnalyticsAfterRegister(method: 'email' | 'facebook' = 'email', email: string) {
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push({
      event: 'sign_up',
      method,
      user_id: this.emailToMd5(email),
    });
  }

  googleAnalyticsAfterDemo(course_id: number, course_name: string) {
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push({
      event: 'demo',
      course_id,
      course_name
    });
  }

  googleAnalyticsViewProduct(courseShopOptions: CourseShopOptionsModel, courseCombined: CourseCombinedModel) {
    window['dataLayer'] = window['dataLayer'] || [];

    const subscriptionItems: any[] = [];

    const item = {
      event: 'view_item',
      currency: null,
      value: null,
      items: [],
    }

    let oneTimePrice = 0;

    courseShopOptions.oneTimePurchases.forEach(otp => {
      if (otp.product.prices) {
        if (otp.product.prices['EUR']) {
          oneTimePrice = otp.product.prices['EUR']['oneTime'] || 0;
          item.currency = 'EUR';
        } else if (otp.product.prices['CZK']) {
          oneTimePrice = otp.product.prices['CZK']['oneTime'] || 0;
          item.currency = 'CZK';
        }
      }
    });

    const allProducts = courseShopOptions.oneTimePurchases.concat(courseShopOptions.subscriptions) || [];

    allProducts.forEach(otp => {
      let price = 0;
      let currency = 'CZK';

      if (otp.product.prices) {

        if (otp.product.prices['EUR']) {
          price = otp.product.prices['EUR']['oneTime'] || otp.product.prices['EUR']['monthly'] || 0;
          currency = 'EUR';
        } else if (otp.product.prices['CZK']) {
          price = otp.product.prices['CZK']['oneTime'] || otp.product.prices['CZK']['monthly'] || 0;
          currency = 'CZK';
        }

      }

      if (!item.currency) {
        item.currency = currency;
      }

      const subscriptionItem = {
        item_id: otp.product.id,
        item_name: otp.product.name,
        price,
        currency,
      }

      subscriptionItems.push(subscriptionItem);
    });

    item.value = oneTimePrice;

    if (!item.value && subscriptionItems.length > 0) {
      item.value = subscriptionItems[0].price;
    }

    if (courseShopOptions.availableAsTrial) {
      subscriptionItems.push({
        item_id: courseCombined.id_eshop,
        item_name: courseCombined.name,
        price: 0,
        currency: item.currency,
      })
    }

    item.items = [...subscriptionItems];

    window['dataLayer'].push(item);

  }

  emailToMd5(email: string): string {
    const hash = CryptoJS.SHA256(email).toString(CryptoJS.enc.Hex);
    return hash;
    // return Md5.hashStr(email);
  }

}

// model for getting data from URL
export interface AffiliateModel {
  oj_source: string;
  oj_id: string;
  lang: string;
}

// model sent to ruby
export interface AffiliateRubyModel {
  eshop_id: number;
  email: string;
  affiliate_partner?: string;
  affiliate_id?: string;
  language: string
  brand?: 'oj' | 'el'
}
